import { render, staticRenderFns } from "./ModalCreatePlatform.vue?vue&type=template&id=5c33cde4"
import script from "./ModalCreatePlatform.vue?vue&type=script&lang=js"
export * from "./ModalCreatePlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports